/**
 * Owner: Masa Bayu
 * File: public-author-local-stores.ts
 * Date:Time: 2026-10-18 23:40
 * Description: Stor setempat halaman author awam §386 — penanda buku (bookmark
 *   kad buku) dan langganan notifikasi (senarai author id). Corak sama dengan
 *   public-author-follow-store: localStorage per peranti + langganan snapshot.
 */

const BOOKMARK_STORAGE_KEY = 'qxread:author-bookmarks:v1';
const SUBSCRIBE_STORAGE_KEY = 'qxread:author-alertsubs:v1';

function readList(key: string): readonly string[] {
  try {
    const raw = window.localStorage.getItem(key);
    if (typeof raw !== 'string') {
      return [];
    }
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return Object.freeze(parsed.filter((item): item is string => typeof item === 'string'));
  } catch {
    return [];
  }
}

function makeStore(key: string): {
  subscribe: (listener: () => void) => () => void;
  snapshot: () => readonly string[];
  toggle: (id: string) => boolean;
  reload: () => void;
} {
  const listeners = new Set<() => void>();
  let snapshot: readonly string[] = readList(key);
  const emit = (): void => {
    for (const listener of listeners) {
      listener();
    }
  };
  return {
    subscribe: (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    snapshot: () => snapshot,
    reload: () => {
      snapshot = readList(key);
      emit();
    },
    toggle: (id) => {
      const has = snapshot.includes(id);
      const next = has
        ? Object.freeze(snapshot.filter((item) => item !== id))
        : Object.freeze([...snapshot, id]);
      snapshot = next;
      try {
        window.localStorage.setItem(key, JSON.stringify(next));
      } catch {
        /* storan penuh/peribadi — keadaan memori kekal untuk sesi ini */
      }
      emit();
      return !has;
    },
  };
}

const bookmarks = makeStore(BOOKMARK_STORAGE_KEY);
const alertSubs = makeStore(SUBSCRIBE_STORAGE_KEY);

export const subscribeAuthorBookmarks = bookmarks.subscribe;
export const getAuthorBookmarkSnapshot = bookmarks.snapshot;
export const toggleAuthorBookmark = bookmarks.toggle;

export const subscribeAuthorAlerts = alertSubs.subscribe;
export const getAuthorAlertSnapshot = alertSubs.snapshot;
export const toggleAuthorAlert = alertSubs.toggle;

/** Selaras semula snapshot modul dengan localStorage selepas stor dibersihkan (ujian). */
export const reloadAuthorLocalStores = (): void => {
  bookmarks.reload();
  alertSubs.reload();
};
